import { useContext, useEffect, useState } from "react";
import { Menu, X, LogIn } from "react-feather";
import { useScreenTransition } from "../../Hooks/useScreenTransition";
import { NotificationContext } from "../../Context/NotificationContext";
import { AuthContext } from "../../Context/AuthContext";
import { DataContext } from "../../Context/DataContext";
import { AccountType } from "../../utility/enums";
import { clearUserStats } from "../../Data/notificationStatsQueue"

import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import { useHistory, useLocation } from "react-router-dom";

import { HashLink } from 'react-router-hash-link';
import { auth } from "../../firebase.config";
import UserMenu, { menuItemsFor } from "../../NewComponents/UserMenu";
import { beginSignOut, endSignOut, homePathFor } from "../../utility/landing";
import { displayName } from "../../utility/accountLabels";


export default function Navbar({ windowSize, isLoginFormOpen, menuItems, defaultPath = "/", border = false }) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (windowSize.width > 1024) setIsOpen(false);
  }, [windowSize]);



  const { transitionTo } = useScreenTransition();
  const { showNotification } = useContext(NotificationContext);
  const { signedIn, clearSignOut } = useContext(AuthContext);
  const { userData, order, setOrder, teamData } = useContext(DataContext);
  const history = useHistory();
  const { pathname } = useLocation();
  // Signed in: the first item of the account menu (orders, or the portal).
  const homeItem = signedIn ? menuItemsFor(userData, teamData)[0] : null;
  // The logo: the portal for someone signed in (as in LogoAuthNavbar), the
  // home page otherwise.
  const logoPath = signedIn && userData ? homePathFor(userData) : "/?redirect=false";
  const accountName = signedIn ? displayName(userData) : "";
  // The avatar's letters, as in the app's header (LogoAuthNavbar).
  const initials = (() => {
    if (!userData) return "U";
    const letters = userData.firstName
      ? userData.firstName[0] + (userData.lastName ? userData.lastName[0] : userData.firstName[1] || "")
      : (userData.name || "U").slice(0, 2);
    return letters.toUpperCase();
  })();


  useEffect(() => {
    if(userData && signedIn){
      if(userData.teamId && teamData){
        if(teamData.newTeam && (userData.teamRole === AccountType.OWNER || userData.teamRole === AccountType.ADMIN) ){
          transitionTo("/account/onboarding")
          return;
        }
      }
    }
  }, [userData, signedIn, teamData])

  const menuItem = menuItems ? menuItems: [
    {
        title: "Features",
        path: "/#features",
        hashLink: true,
    },
    {
        title: "Pricing",
        path: "/#pricing",
        hashLink: true,
    },
    
    {
        title: "Reviews",
        path: "/reviews",
    },
    
    {
        title: "Contact",
        path: "/contact",
    },
   
    {
        title: "FAQs",
        path: "/faq",
      },
    {
        // Static pages served by Hosting, not React routes: needs a full page load.
        title: "Blog",
        path: "/blog",
        external: true,
      },

  ];

  const changeLoginOpen = () => {
    isLoginFormOpen(true);
  };
  const handleMenuClick = (item, e) => {
    if (item.external) {
      window.location.assign(item.path);
      return;
    }
    if (pathname === defaultPath && item.id) {
      e.preventDefault();
      const element = document.getElementById(item.id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else if (pathname !== defaultPath && item.id) {
      e.preventDefault();
      transitionTo(defaultPath, e);

      setTimeout(() => {
        const element = document.getElementById(item.id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 200);
    } else {
      transitionTo(item.path, e);
    }
  };

  const signOut = () => {
    clearUserStats(userData?.id);
    setIsOpen(false);
    beginSignOut();
    history.push(defaultPath);

      auth
      .signOut()
      .then(() => {
        showNotification("Success", "You have signed out.", "success");
        clearSignOut();
      })
      .catch(() => {
        showNotification(
          "Error",
          "There was an error signing out. Please, try again.",
          "error"
        );
      })
      .finally(endSignOut);
  };

  const gotoOrder = () => {
    if (!signedIn) {
      transitionTo("/order/type");
      return;
    }
    if (signedIn && userData && userData.teamId) {
      transitionTo("/order/documents");
      localStorage.setItem(
        "order",
        JSON.stringify({ ...order, type: "business" })
      );
      setOrder((q) => ({ ...q, type: "business" }));
    } else {
      transitionTo("/order/documents");
      localStorage.setItem(
        "order",
        JSON.stringify({ ...order, type: "personal" })
      );
      setOrder((q) => ({ ...q, type: "personal" }));
    }

    // Fixing incorrect logical conditions
  };

  return (
    <nav className={`container bg-white mx-auto md:py-4 py-2 px-4 md:px-6 rounded-full ${border ? "border-[1px] border-[#eee]" : ""}`}>
      {/* Desktop Nav */}
      <div className=" lg:flex  hidden justify-between items-center">
        <div className=" xl:w-3/5 w-fit flex items-center justify-between">
          <img
            src={require("../../assets/logo.png")}
            alt="Logo eVerbary"
            className="h-10 w-auto cursor-pointer"
            onClick={(e) => transitionTo(logoPath, e)}
          />

          <div className="flex items-center xl:gap-1">
            {menuItem.map((item, index) => (
              item.hashLink ? <div key={index}
              className={` xl:px-4 px-2 py-1  whitespace-nowrap cursor-pointer text-tertiary font-semibold text-lg hover:rounded-full hover:bg-[#D0EEF2]`}
              >
                <HashLink smooth to={item.path}>{item.title}</HashLink>
              </div> :
              <div
                key={index}
                className={` xl:px-4 px-2 py-1  whitespace-nowrap cursor-pointer text-tertiary font-semibold text-lg hover:rounded-full hover:bg-[#D0EEF2]`}
                onClick={(e) => handleMenuClick(item, e)}
              >
                {item.title}
              </div>
            ))}
          </div>
        </div>

       

        <div className="xl:w-2/5 w-fit flex items-center justify-end gap-4">
          <div className="flex gap-2">
            <button
              className="bg-primary text-white px-4 py-2 rounded-full hover:opacity-80 font-semibold  whitespace-nowrap"
              onClick={(e) => gotoOrder(e)}
            >
              Create Order
            </button>
            <button
              className="px-4 py-2 rounded-full hover:opacity-80 border-[1px] border-tertiary text-tertiary font-semibold  whitespace-nowrap"
              onClick={(e) => transitionTo("/quote/details", e)}
            >
              Free Quote
            </button>
          </div>
          {signedIn ? (
            <div className="relative group">
              {/* Signed in: the same round avatar with their initials as in the
                  app's header (not a "My orders" / "Portal" pill: feedback 14-oct).
                  Hovering opens the account menu; clicking goes to their orders
                  (or the portal). */}
              <button
                className="flex items-center justify-center w-10 h-10 rounded-full bg-[#e6e7e9] hover:bg-[#d2d3d7] text-[#030F23] text-sm font-semibold transition-colors"
                title={accountName ? `Signed in as ${accountName}` : "Signed in"}
                aria-label={homeItem ? homeItem.label : "My account"}
                data-testid="home-avatar"
                onClick={(e) => homeItem && transitionTo(homeItem.path, e)}
              >
                {initials}
              </button>
              {/* The same avatar menu on every page (EV-client-1002). */}
              <div className="absolute right-0 hidden group-hover:flex group-focus-within:flex flex-col bg-white shadow-lg rounded-lg z-30 mt-0 headerUserMenuDropdown">
                <UserMenu onNavigate={(path, e) => transitionTo(path, e)} onSignOut={signOut} />
              </div>
            </div>
          ) : (
            <button
              className="p-2 rounded-full border-2  border-tertiary "
              onClick={(e) => changeLoginOpen()}
            >
              <LogIn className="text-tertiary" />
            </button>
          )}
        </div>
      </div>

      {/* Mobile Nav */}
      <div className="flex justify-between items-center lg:hidden">
        <img
          src={require("../../assets/logo.png")}
          alt="Logo eVerbary"
          className="h-10 w-auto cursor-pointer"
          onClick={(e) => {
            transitionTo(logoPath, e);
            setIsOpen(false);
          }}
        />

        <div className="flex items-center gap-2">
          {signedIn && homeItem && (
            <button
              className="flex items-center justify-center w-10 h-10 rounded-full bg-[#e6e7e9] text-[#030F23] text-sm font-semibold"
              title={accountName ? `Signed in as ${accountName}` : "Signed in"}
              aria-label={homeItem.label}
              onClick={(e) => transitionTo(homeItem.path, e)}
            >
              {initials}
            </button>
          )}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="p-2 rounded-full bg-primary border-2  border-white text-white"
          >
            {isOpen ? <X /> : <Menu />}
          </button>
        </div>
      </div>

      {isOpen && (
        <div className="fixed top-0 left-0 w-full h-full bg-[#EFF3F5]  flex flex-col gap-4 overflow-y-auto justify-between py-12 px-8 z-50 transition-all">
          <div className="flex flex-col w-full gap-4 container mx-auto">
            <div className="flex justify-between items-center  bg-white md:py-4 py-2 px-4 md:px-6 rounded-full shadow-sm">
              <img
                src={require("../../assets/logo.png")}
                alt="Logo eVerbary"
                className="h-10 w-auto cursor-pointer"
                onClick={(e) => {
                  transitionTo(logoPath, e);
                  setIsOpen(false);
                }}
              />
              <button
                onClick={() => setIsOpen(false)}
                className="p-2 rounded-full bg-primary text-white"
              >
                <X />
              </button>
            </div>
            {menuItem.map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-full py-3 px-6 text-start text-tertiary font-semibold cursor-pointer shadow-sm hover:text-primary"
                onClick={(e) => {
                  handleMenuClick(item, e);
                  setIsOpen(false);
                }}
              >
                {item.title}
              </div>
            ))}
            {signedIn && userData && (
              <UserMenu variant="sheet" onNavigate={(path, e) => transitionTo(path, e)} onSignOut={signOut} onDone={() => setIsOpen(false)} />
            )}
          </div>
          <div className="flex flex-col gap-3 container mx-auto">
            <button
              className="bg-primary text-white py-3 rounded-full  hover:opacity-80 font-semibold"
              onClick={(e) => gotoOrder(e)}
            >
              Create Order
            </button>
            <button
              className="py-3 rounded-full border-2 border-tertiary text-tertiary font-semibold"
              onClick={(e) => transitionTo("/quote/details", e)}
            >
              Free Quote
            </button>

            {!signedIn && (
              <button
                className="p-2 rounded-full border-2  border-tertiary hover:opacity-80 font-semibold whitespace-nowrap"
                onClick={(e) => {
                  changeLoginOpen();
                  setIsOpen(false);
                }}
              >
                Login
              </button>
            )}
          </div>
        </div>
      )}
    </nav>
  );
}
